import { useEffect, useState } from "react";

export default function ViewPayout({ payout }) {
  const [paidAt, setPaidAt] = useState("");
  const [amount, setAmount] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");
  const [note, setNote] = useState("");
  const [payoutImages, setPayoutImages] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    if (!payout) return;

    setPaidAt(payout.paidAt ? payout.paidAt.split("T")[0] : "");
    setAmount(payout.amount ?? "");
    setPaymentMethod(payout.paymentMethod ?? "");
    setNote(payout.note ?? "");
    setPayoutImages(payout.payoutRecordUrl ?? []);
  }, [payout]);

  return (
    <div className="max-w-md mx-auto bg-white rounded-2xl shadow-sm border border-gray-200 p-6">
      <h2 className="text-xl font-semibold text-gray-800 mb-6">
        Payout Details
      </h2>

      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          Paid At
        </label>
        <input
          type="date"
          value={paidAt}
          readOnly
          className="w-full rounded-lg border border-gray-300 px-3 py-2 bg-gray-100 cursor-not-allowed"
        />
      </div>

      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          Amount
        </label>
        <input
          type="text"
          value={amount}
          readOnly
          className="w-full rounded-lg border border-gray-300 px-3 py-2 bg-gray-100 cursor-not-allowed"
        />
      </div>

      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          Payment Method
        </label>
        <input
          type="text"
          value={paymentMethod}
          readOnly
          className="w-full rounded-lg border border-gray-300 px-3 py-2 bg-gray-100 cursor-not-allowed"
        />
      </div>

      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          Note
        </label>
        <textarea
          value={note}
          readOnly
          rows={3}
          className="w-full rounded-lg border border-gray-300 px-3 py-2 bg-gray-100 cursor-not-allowed"
        />
      </div>

      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-600 mb-2">
          Payout Records
        </label>

        <div className="flex flex-wrap gap-2">
          {payoutImages.length > 0 ? (
            payoutImages.map((img, idx) => {
              const imgUrl = `${process.env.REACT_APP_API_URL}${img}`;
              return (
                <img
                  key={idx}
                  src={imgUrl}
                  alt={`Payout ${idx + 1}`}
                  className="w-20 h-20 object-cover rounded cursor-pointer hover:scale-105 transition"
                  onClick={() => setSelectedImage(imgUrl)}
                />
              );
            })
          ) : (
            <span className="text-gray-500">No images available</span>
          )}
        </div>
      </div>

      {selectedImage && (
        <div
          className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
          onClick={() => setSelectedImage(null)}
        >
          <img
            src={selectedImage}
            alt="Preview"
            className="max-h-[90%] max-w-[90%] rounded-lg"
            onClick={(e) => e.stopPropagation()}
          />
          <button
            onClick={() => setSelectedImage(null)}
            className="absolute top-5 right-5 text-white text-2xl font-bold"
          >
            ×
          </button>
        </div>
      )}
    </div>
  );
}
